import { createFileRoute, notFound } from "@tanstack/react-router";

import { TaskPage } from "../../workspaces/projects/pages/TaskPage";
import { useProjectId } from "../../shell/project";

/** A task's address is its id; anything else here names no task. */
const TASK_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export const Route = createFileRoute("/_console/p/$org/$project/tasks/$taskId")({
  beforeLoad: ({ params }) => {
    if (!TASK_ID.test(params.taskId)) throw notFound();
  },
  component: ProjectTaskPageRoute,
});

function ProjectTaskPageRoute() {
  const { taskId } = Route.useParams();
  return <TaskPage projectId={useProjectId()} taskId={taskId} />;
}
